import { ConnectionCreatorScenarioCategory } from "types/enums";

import FormStructureData = App.Data.FormStructureData;
import FormFieldData = App.Data.FormFieldData;

export const STRUCTURE_SCENARIO_CATEGORIES: ConnectionCreatorScenarioCategory[] = [
    ConnectionCreatorScenarioCategory.StructureValidate,
    ConnectionCreatorScenarioCategory.StructureModify,
    ConnectionCreatorScenarioCategory.StructureAutocomplete,
];

const STRUCTURE_SCENARIO_CATEGORIES_SET = new Set<ConnectionCreatorScenarioCategory>(STRUCTURE_SCENARIO_CATEGORIES);

export const isStructureScenarioCategory = (category?: string | null): boolean =>
    STRUCTURE_SCENARIO_CATEGORIES_SET.has(category as ConnectionCreatorScenarioCategory);

export const mergeScenarioFormFields = (formStructures: FormStructureData[]): FormFieldData[] => {
    const fieldsBySystemName = new Map<string, FormFieldData>();
    const fallbackFields: FormFieldData[] = [];

    formStructures.forEach((formStructure) => {
        const sortedFields = [...(formStructure.formFields ?? [])].sort((a, b) => a.weight - b.weight);

        sortedFields.forEach((field) => {
            const key = field.system_name?.trim();

            if (!key) {
                fallbackFields.push(field);
                return;
            }

            if (!fieldsBySystemName.has(key)) {
                fieldsBySystemName.set(key, field);
            }
        });
    });

    return [...fieldsBySystemName.values(), ...fallbackFields];
};
